import { axiosInstance } from "./configURL";

export const receiptServices = {
  submitReceiptApi: (data) => {
    return axiosInstance.post("/marico/submit_receipt", data, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },
  submitReceiptTimeApi: (data) => {
    return axiosInstance.post("/marico/submit_receipt_time", data, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },
};
